export const HEADING = "Cancel car rental";
export const SUBHEADING =
  "This rental is managed by the provider. To cancel this rental, please visit the carrier website to manage your booking.";
export const SUBHEADING_AGENT =
  "To cancel this car rental, please contact our customer support team and someone will assist you.";
export const CONTACT_SUPPORT = "Contact support";
export const CANCEL = "Cancel";
export const PROVIDER_CTA = "Continue to the provider website";
